import { Helper } from "./helper.js";
import { MetaDataHelper } from "./metaDataHelper.js";
import { NotificationHelper } from "./notificationHelper.js";
import { Config } from "../config/config.js";
import { ComponentType } from "./ingridHelper.js";

export class ValidatorHelper {
    public static create(data: ValidatorHelperData) {
        return (function () {
            let validatorCalled = false;

            function getRequiredProperties(metaDataObj = null) {
                var reqProps = [], props = [], meta = metaDataObj || data.metaData;
                for (let i = 0; i < meta.tabs.length; i++) {
                    if (Helper.hasValue(meta.tabs[i].regions)) {
                        for (let y = 0; y < meta.tabs[i].regions.length; y++) {
                            if (Helper.hasValue(meta.tabs[i].regions[y].fields)) {
                                for (let z = 0; z < meta.tabs[i].regions[y].fields.length; z++) {
                                    const entProp = {
                                        model: meta.tabs[i].regions[y].fields[z].model,
                                        name: meta.tabs[i].regions[y].fields[z].name,
                                        tabName: meta.tabs[i].title,
                                        tabIndex: i,
                                        readOnly: Helper.hasValue(meta.tabs[i].regions[y].fields[z].readOnlyTextField) ? meta.tabs[i].regions[y].fields[z].readOnlyTextField : meta.tabs[i].regions[y].fields[z].readOnly,
                                        readOnlyCondition: null,
                                        isIndividual: Helper.hasValue(metaDataObj),
                                        type: meta.tabs[i].regions[y].fields[z].type,
                                        readOnlyTextField: meta.tabs[i].regions[y].fields[z].readOnlyTextField,
                                        readOnlyTextFieldCondition: null,
                                        visibleCondition: meta.tabs[i].regions[y].fields[z].visibleCondition
                                    };
                                    //if "readOnly" is a condition and not boolean, reevaluate the condition
                                    if (typeof entProp.readOnly === "string") {
                                        entProp.readOnlyCondition = entProp.readOnly;//meta.tabs[i].regions[y].fields[z].readOnlyTextField;
                                        entProp.readOnly = data.handleEval(entProp.readOnly);//data.handleEval(meta.tabs[i].regions[y].fields[z].readOnlyTextField);
                                    }
                                    //if "readOnlyTextField" is a condition and not boolean, reevaluate the condition
                                    if (typeof entProp.readOnlyTextField === "string") {
                                        entProp.readOnlyTextFieldCondition = entProp.readOnlyTextField;
                                        entProp.readOnlyTextField = data.handleEval(entProp.readOnlyTextField);
                                    }

                                    if (typeof entProp.visibleCondition === "string") {
                                        entProp.visibleCondition = data.handleEval(entProp.visibleCondition);
                                    }

                                    props.push(entProp);
                                    if (meta.tabs[i].regions[y].fields[z].type !== "is-panelbar-details"
                                        && (typeof meta.tabs[i].regions[y].fields[z].required === "string" ? data.handleEval(meta.tabs[i].regions[y].fields[z].required) === true : meta.tabs[i].regions[y].fields[z].required === true)
                                        && meta.tabs[i].regions[y].fields[z].model.indexOf("entity.") !== -1) {
                                        const value = Helper.getValueByPathString(entProp.isIndividual ? data.entity.IndividualFields : { entity: data.entity }, meta.tabs[i].regions[y].fields[z].model);
                                        if (!Helper.hasValue(value) || value === "" || (Array.isArray(value) && value.length === 0)) {
                                            reqProps.push(entProp);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                if (!Helper.hasValue(metaDataObj) && Helper.hasValue(data.individualMetaData)) {
                    var tmpMeta = getRequiredProperties(data.individualMetaData);
                    Array.prototype.push.apply(reqProps, tmpMeta.required);
                    Array.prototype.push.apply(props, tmpMeta.all);
                }

                return { required: reqProps, all: props };
            }

            function getRequiredPropertiesInGrid(gridOptions: any) {
                function getRequiredProperties(columns: any[]) {
                    let requiredProps: InGridRequiredProp[] = [];
                    for (let column of columns) {
                        if (Helper.hasValue(column.required)) {
                            let field: string = column.field;
                            field = field.replace("Ind_", "IndividualFields.");
                            let requiredProp: InGridRequiredProp = { field: field, required: column.required, visible: column.visible };
                            requiredProps.push(requiredProp);
                        }

                        if (column.type.toLowerCase() == ComponentType.MultiColumn) {
                            let multiColumn = column;
                            let multiColumnRequiredProps = getRequiredProperties(multiColumn.columns);
                            requiredProps = requiredProps.concat(multiColumnRequiredProps);
                        }
                    }

                    return requiredProps;
                }

                if (!gridOptions.columns)
                    return [];
                let columns = gridOptions.columns;
                let requiredProps: InGridRequiredProp[] = getRequiredProperties(columns);
                return requiredProps;
            }

            function validateInGrid(requiredProps: InGridRequiredProp[], dataItems: any[]) {
                for (let dataItem of dataItems) {
                    for (let requiredProp of requiredProps) {
                        let required = data.handleEval(requiredProp.required, { row: dataItem });
                        let visible = data.handleEval(requiredProp.visible, { row: dataItem });
                        if (Helper.hasValue(visible) && !visible)
                            continue;
                        try {
                            let value = data.handleEval(requiredProp.field, { ...dataItem });
                            if (required && (!Helper.hasValue(value) || value === "")) {
                                return false;
                            }
                        } catch {
                            if (required)
                                return false;
                        }
                    }
                }

                return true;
            }

            function showRequiredProperties(requiredProperties, allProps, validatorErrors) {
                var requiredFormat = Config.translations.mandatoryField, formatted = [], finalErrors = [], finalMessage = "";

                if (requiredFormat && Array.isArray(requiredProperties)) {
                    formatted = requiredProperties.map(function (obj) {
                        return { msg: Helper.formatString(requiredFormat, obj.name), tabName: obj.tabName };
                    });
                }

                finalErrors = validatorErrors.map(function (obj) {
                    var meta;
                    for (var i = 0; i < allProps.length; i++) {
                        if (allProps[i].name && obj.indexOf(allProps[i].name) >= 0) {
                            meta = allProps[i];
                            break;
                        }
                    }
                    if (!Helper.hasValue(meta)) {
                        return null;
                    } else {
                        return { msg: obj, tabName: meta.tabName };
                    }
                }).filter(function (obj) {
                    return Helper.hasValue(obj);
                });

                formatted.forEach(function (obj) {
                    var found = false;
                    for (var i = 0; i < finalErrors.length; i++) {
                        if (finalErrors[i].msg === obj.msg) {
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        finalErrors.push(JSON.parse(JSON.stringify(obj)));
                    }
                });

                if (finalErrors.length > 0) {
                    const finalMessage = finalErrors.map(function (obj) {
                        let result = obj.msg;
                        if (!Helper.isNullOrEmpty(obj.tabName)) {
                            result += ` <i>(${obj.tabName})</i><br>`
                        }
                        return result;
                    }).join("\n");

                    NotificationHelper.showWarningMessage(finalMessage, { timeOut: 5000 });
                }
            }

            function setReadOnlyForRequired(req, roState) {
                for (let i = 0; i < req.length; i++) {
                    if (req[i].readOnly === true) {
                        const tmpReq = req[i];
                        if (tmpReq.type === "is-search-field" && tmpReq.readOnlyTextField === true) {
                            const metaProps = MetaDataHelper.getFieldByProperty(tmpReq.isIndividual ? data.individualMetaData : data.metaData, "model", tmpReq.model);
                            metaProps.readOnlyTextField = roState ? tmpReq.readOnlyTextFieldCondition || roState : roState;
                        } else {
                            MetaDataHelper.setReadOnly(tmpReq.isIndividual ? data.individualMetaData : data.metaData, tmpReq.model, roState ? tmpReq.readOnlyCondition || roState : roState);
                        }
                    }
                }
            }

            var api: ValidatorHelperAPI = {
                validate: function (additionalRequired?: Array<{ name: string; tabName: string; }>, respectVisibleCondition?: boolean) {
                    this.hideMessages();
                    const meta = getRequiredProperties(null);

                    if (respectVisibleCondition === true) {
                        meta.required = meta.required.filter(x => x.visibleCondition == true);
                    }

                    ///extra
                    if (Array.isArray(additionalRequired)) {
                        for (let i = 0; i < additionalRequired.length; i++) {
                            meta.required.push(additionalRequired[i]);
                        }
                    }
                    ///end extra
                    setReadOnlyForRequired(meta.required, false);
                    data.validator.validate();
                    const vErrors = data.validator.errors();
                    showRequiredProperties(meta.required, meta.all, vErrors);
                    this.showValidationMessages(function () {
                        setReadOnlyForRequired(meta.required, true);
                    });
                    validatorCalled = true;

                    return vErrors.length === 0 && meta.required.length === 0;
                },
                validateInGrids: function (inGridValidations: InGridValidation[]) {
                    let vErrors: string[] = [];

                    for (let inGridValidation of inGridValidations) {
                        let requiredInGridProps = getRequiredPropertiesInGrid(inGridValidation.gridOptions);
                        let dataItems = data.handleEval(inGridValidation.model);
                        let isGridValid = validateInGrid(requiredInGridProps, dataItems);
                        if (!isGridValid) {
                            let error = Helper.getTranslation("WebSMS.InGrid.MsgRequiredFieldsGrid").replace("{0}", inGridValidation.gridName);
                            vErrors.push(error);
                        }
                    }

                    if (vErrors.length > 0)
                        NotificationHelper.showWarningMessage(vErrors.join("<br/><br/>"), { timeOut: 5000 });

                    return vErrors.length === 0;
                },
                showValidationMessages: function (callback) {
                    data.validator.validate();
                    if (callback) {
                        callback();
                    }
                },
                hideMessages: function () {
                    data.validator.hideMessages();
                },
                isCalled: function () {
                    return validatorCalled;
                }
            };

            return api;
        })();
    }
}

export interface ValidatorHelperAPI {
    validate(additionalRequired?: Array<{ name: string; tabName: string; }>, respectVisibleCondition?: boolean): boolean;
    validateInGrids(inGridValidations: InGridValidation[]): boolean;
    showValidationMessages(callback: any);
    hideMessages();
    isCalled(): boolean;
}

export interface ValidatorHelperData {
    validator: kendo.ui.Validator;
    entity: any;
    metaData: any;
    individualMetaData: any;
    handleEval(action: any, prepare?: any);
}

interface InGridRequiredProp {
    field: string;
    required: string;
    visible: string;
}

export interface InGridValidation {
    gridOptions: any;
    model: string;
    gridName: string;
}